import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db, storage } from "../../../firebaseConfig.js"; // Ensure 'db' is imported for Firestore
import { deleteUser, onAuthStateChanged, updateEmail, updatePassword, updateProfile } from "firebase/auth";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore"; // Firestore update methods
import "./Settings.css";
import Button from "@mui/material/Button";

function Settings() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState(""); // New state for firstName
  const [lastName, setLastName] = useState(""); // New state for lastName
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        setEmail(currentUser.email);
        const displayNameArray = currentUser.displayName ? currentUser.displayName.split(" ") : ["", ""];
        setFirstName(displayNameArray[0]);
        setLastName(displayNameArray.slice(1).join(" "));
      } else {
        navigate("/");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      if (user) {
        // Update email if it has changed
        if (email !== user.email) {
          await updateEmail(user, email);
          await updateDoc(doc(db, "users", user.uid), { email }); // Update Firestore
          alert("Email updated successfully!");
        }
        // Update firstName and lastName if they have changed
        if (firstName !== user.displayName.split(" ")[0] || lastName !== user.displayName.split(" ").slice(1).join(" ")) {
          const fullName = `${firstName} ${lastName}`;
          await updateProfile(user, { displayName: fullName });
          await updateDoc(doc(db, "users", user.uid), { firstName, lastName }); // Update Firestore
          alert("Name updated successfully!");
        }
        // Update password if provided
        if (password) {
          await updatePassword(user, password);
          alert("Password updated successfully!");
        }
      }
    } catch (error) {
      alert(error.message);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the file from the input
    if (!file) return;

    const storageRef = ref(storage, `profilePictures/${auth.currentUser.uid}/${file.name}`);
    uploadBytes(storageRef, file)
      .then((snapshot) => {
        console.log("Uploaded a file!", snapshot);

        // Get the download URL
        getDownloadURL(snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);
          setImageUrl(downloadURL);

          // Update user profile with the new avatar URL
          updateProfile(auth.currentUser, {
            photoURL: downloadURL,
          })
            .then(() => {
              console.log("Profile updated successfully");
              setAvatarUrl(downloadURL);
            })
            .catch((error) => {
              console.error("Error updating user profile:", error);
            });
        });
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const handleHomeClick = () => {
    navigate("/home");
  };

  const handleDeleteAccount = () => {
    const confirmed = window.confirm("Are you sure you want to delete your account? This cannot be undone.");

    if (confirmed) {
      const user = auth.currentUser;

      deleteUser(user)
        .then(() => {
          alert("Account deleted successfully.");
          navigate("/");
        })
        .catch((error) => {
          if (error.code === "auth/requires-recent-login") {
            alert("Please sign in again to delete your account.");
            navigate("/");
          } else {
            console.error("Error deleting account:", error);
            alert("An error occurred while attempting to delete the account.");
          }
        });
    }
  };

  return (
    <center>
      <br />
      <br />
      <Button onClick={() => window.history.back()}>Back</Button>

      <div>
        <form className="settings-container" onSubmit={handleUpdate}>
          <div className="segment">
            <h2>User Settings</h2>
          </div>
          <div className="segment">
            <label>
              First name:
              <input
                className="field"
                type="text"
                value={firstName}
                placeholder="First name"
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
            </label>
            <label>
              Last name:
              <input className="field" type="text" value={lastName} placeholder="Last name" onChange={(e) => setLastName(e.target.value)} required />
            </label>
            <label>
              Email:
              <input className="field" type="email" value={email} placeholder="Email" onChange={(e) => setEmail(e.target.value)} required />
            </label>
            <label>
              New Password:
              <input
                className="field"
                type="password"
                value={password}
                placeholder="Leave blank to keep current"
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
          </div>
          <button type="submit" className="button">
            Update Settings
          </button>
        </form>
      </div>
      <button className="delButton" onClick={handleDeleteAccount}>
        Delete Account
      </button>
    </center>
  );
}

export default Settings;
